const DETAIL_DEMANDE_IMPRESSION = {
  title: 'Détail demande d\'impression',
  alerteCommentaire: 'Attention, cette demande possède un commentaire.',
  alerteCommentaireHead: 'Demande d\'impression avec commentaire',
  breadcrumb: {
    detail: 'Détail demande d\'impression',
  },
  infoGenerale: {
    title: 'Informations générales',
    dateDemandeImpression: 'Date demande',
    etat: 'Etat',
    couleur: 'Couleur',
    typeOt: 'Type d\'impression ',
    client: 'Client',
    demandeur: 'Contact demandeur',
    receveur: 'Contact receveur',
    quantite: 'Quantité',
    commentaire: 'Commentaire',
    soldeStock: 'Solde stock',
    nomVariante: 'Nom variante',
    OTs: 'OT(s) technique',
    dateLimite: 'Date limite',
    description: 'Description',
    tags: 'Tags',
    nomFichierRip: 'Nom du fichier',
    graphisteEnCharge: 'Graphiste en charge',
  },
  dispositif: {
    title: 'Dispositif',
    typeDispositif: 'Type dispositif',
    typeMateriel: 'Type matériel',
    adresse: 'Adresse',
    aucunDispositif: 'Aucun dispositf présent dans la demande d\'impression',
  },
  campagne: {
    title: 'Campagne',
    libelleLogo: 'Campagne : {name}',
  },
  demandeLiee: {
    title: 'Demande d\'impression',
  },
  actions: {
    updateGraphiste: 'Je prends en charge',
    addCampagne: 'Ajouter une campagne',
  },
  messages: {
    graphisteChangeSuccess: 'Graphiste en charge modifié avec succès',
    campagneChangeSuccess: 'Campagne modifiée avec succès',
  },
  popup: {
    graphiste: {
      title: 'Prise en charge de la demande d\'impression',
      desc: 'En effectuant cette action, vous serez le graphiste en charge de la demande d\'impression. Êtes-vous sûr de vouloir continuer ?',
    },
  },
};

export default DETAIL_DEMANDE_IMPRESSION;
